import DocumentsSection from "@/components/agent/DocumentsSection";
import KnowledgeTab from "@/components/agent/KnowledgeTab";
import FaqsTab from "@/components/agent/FaqsTab";

/** Base de conocimiento completa del agente: documentos subidos,
 * informacion cualitativa por tratamiento y preguntas frecuentes. */
export default function KnowledgeBaseTab({
  documents, knowledge, faqs, loading,
  onUploadDocument, onDeleteDocument, onUpdateKnowledge, onCreateFaq, onUpdateFaq, onDeleteFaq,
}) {
  return (
    <div className="space-y-8">
      <DocumentsSection documents={documents} onUpload={onUploadDocument} onDelete={onDeleteDocument} />

      <div className="pt-6 border-t border-border">
        <h3 className="text-sm font-medium text-foreground mb-1">Tratamientos</h3>
        <p className="text-xs text-muted-foreground mb-3">Informacion detallada de cada tratamiento del catalogo (precio y duracion vienen de Servicios).</p>
        <KnowledgeTab knowledge={knowledge} loading={loading} onUpdate={onUpdateKnowledge} />
      </div>

      <div className="pt-6 border-t border-border">
        <h3 className="text-sm font-medium text-foreground mb-1">Preguntas frecuentes</h3>
        <p className="text-xs text-muted-foreground mb-3">Preguntas comunes de los leads y la respuesta que debe dar el agente.</p>
        <FaqsTab faqs={faqs} loading={loading} onCreate={onCreateFaq} onUpdate={onUpdateFaq} onDelete={onDeleteFaq} />
      </div>
    </div>
  );
}
